import type { ReactNode } from 'react';

import type { useModal } from '@/components/modals/new/use-modal';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/new-ui/dialog';

type EstateFormDialogProps = {
  modal: ReturnType<typeof useModal>;
  title: string;
  /** The estate form rendered with options.newUi */
  children: ReactNode;
};

/** Dialog shell of the redesign for the estate form: title on top, the form fills the rest. */
export const EstateFormDialog = ({ modal, title, children }: EstateFormDialogProps) => (
  <Dialog open={modal.isOpen} onOpenChange={(open) => !open && modal.dismiss()}>
    <DialogContent
      className="flex max-h-[85vh] flex-col overflow-hidden p-0 sm:max-w-lg"
      aria-describedby={undefined}
    >
      <DialogHeader className="px-6 pb-0 pt-6">
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>
      {children}
    </DialogContent>
  </Dialog>
);
